import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';

import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { DataManagerController } from '../application/data-manager-controller';
import { DataManagerColunaGrupo } from '../contracts/data-manager.model';

@Component({
  selector: 'app-data-manager-grupo',
  templateUrl: './data-manager-grupo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkDrag, CdkDropList, MatIcon, MatTooltip],
})
export class DatamanagerGrupoComponent<T> {
  dmController = input.required<DataManagerController<T>>();

  grupos = computed(() => this.dmController().gruposColunas());

  dropGrupo(event: CdkDragDrop<DataManagerColunaGrupo>) {
    this.dmController().grupoMover(event.item.data, event.currentIndex + 1);
  }

  grupoExpandirRetrairTudo(grupo: DataManagerColunaGrupo, expandir: boolean) {
    this.dmController().grupoExpandirRetrairTudo(grupo, expandir);
  }

  grupoRemover(grupo: DataManagerColunaGrupo) {
    this.dmController().grupoRemover(grupo);
  }
}
